import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppProvider, buildApolloClient } from '@reverbdotcom/discovery-ui';
import { parseMeta, frontendCurrentUser } from './parse_meta';
import { get } from 'lodash';

const CLASS_NAME_ATTR = 'data-react-class';
const PROPS_ATTR = 'data-react-props';

function reloader() {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    return require('react-hot-loader').hot;
  }
  return () => (constructor) => constructor;
}

const hotReloader = reloader();
const user = get(frontendCurrentUser(), 'user', {});
const state = parseMeta('apollo-state');

const client = buildApolloClient(user);
client.restore(state);

const render = (global, dom) => {
  const all = dom.querySelectorAll('[data-react-class]');
  [].forEach.call(all, (component) => { // querySelectorAll returns a NodeList not an []
    try {
      const name = component.getAttribute(CLASS_NAME_ATTR);
      const props = component.getAttribute(PROPS_ATTR);
      const parsed = JSON.parse(props);

      const constructor = name
        .split('.')
        .reduce((obj, index) => obj[index], global);

      if (!constructor) {
        throw new Error(`Could not find React component ${name}`);
      }

      const componentElement = React.createElement(hotReloader(module)(constructor), parsed);

      const wrapped = React.createElement(
        AppProvider,
        {
          user,
          client,
          url: window.location.href,
          referer: document.referrer,
        },
        componentElement,
      );

      ReactDOM.render(wrapped, component);
    } catch (e) {
      console.error(e);
    }
  });
};

export default {
  render,
};

document.addEventListener('DOMContentLoaded', render.bind(this, window, document));



// WEBPACK FOOTER //
// ./javascripts/components/react_renderer.js